import Image from '@atoms/Image';
import { Link } from '@ui/atoms';
import { useMemo } from 'react';
import BlogListItemContent from '../BlogListItemContent';
import { getBlogImageUrlUpdated } from '../helper';

function BlogListItem({
    item,
    cssClassName,
    isLoading,
    isFeaturedBlogContent,
    isRelatedBlog
}) {
    const featuredImage = (item.featuredImage?.node?.mediaItemUrl ||
        item.featuredImage?.node?.sourceUrl) && (
            <Image
                src={
                    getBlogImageUrlUpdated(item.featuredImage?.node?.mediaItemUrl ||
                    item.featuredImage?.node?.sourceUrl)
                }
                alt="featuredImage"
                className="img-fluid rounded-t-3xl h-56 lg:h-52 xl:h-64 object-cover mx-auto"
            />
        );
    const content = useMemo(
        () => (
            <div className="h-full bg-basicWhite rounded-3xl max-w-[395px] flex flex-col">
                <Link href={`/blogs/${encodeURIComponent(item?.slug)}`} legacyBehavior>
                    <figure
                        className={`rounded-t-3xl h-56 lg:h-52 xl:h-64 cursor-pointer ${!featuredImage && 'bg-gray-50'
                            }`}
                    >
                        {isLoading ? (
                            <div className="h-56 lg:h-48 xl:h-64 skeleton-loader mb-6 rounded-t-3xl"></div>
                        ) : (
                            featuredImage
                        )}
                    </figure>
                </Link>

                <div className="rounded-b-3xl flex flex-1 flex-col justify-between">
                    <BlogListItemContent
                        item={item}
                        isLoading={isLoading}
                        isFeaturedBlogContent={isFeaturedBlogContent}
                        isRelatedBlog={isRelatedBlog}
                    />
                </div>
            </div>
        ),
        [item, isLoading]
    );

    return !isLoading ? (
        <div className={cssClassName} id={item.id}>
            {content}
        </div>
    ) : (
        <div className={cssClassName} key={item.id}>
            {content}
        </div>
    );
}

export default BlogListItem;
